import Image1 from "../assets/cards/1.jpg"
import Image2 from "../assets/cards/2.jpg"

export const getCardBackground = (designTypeID: number | string) => {
    switch (designTypeID) {
        case 1:
            return `url("${Image1}") center/cover no-repeat`;
        case 2:
            return `url("${Image2}") center/cover no-repeat`;
        default:
            return `linear-gradient(150deg, #1d6fe8, #2B7FFF)`;
    }
}